/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationCombo200ResponseCategoriesInnerProductsInner } from './GetOrganizationCombo200ResponseCategoriesInnerProductsInner';
import {
    GetOrganizationCombo200ResponseCategoriesInnerProductsInnerFromJSON,
    GetOrganizationCombo200ResponseCategoriesInnerProductsInnerFromJSONTyped,
    GetOrganizationCombo200ResponseCategoriesInnerProductsInnerToJSON,
    GetOrganizationCombo200ResponseCategoriesInnerProductsInnerToJSONTyped,
} from './GetOrganizationCombo200ResponseCategoriesInnerProductsInner';

/**
 * 
 * @export
 * @interface GetOrganizationCombo200ResponseCategoriesInner
 */
export interface GetOrganizationCombo200ResponseCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    comboId: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    selectedByDefault: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    max: number;
    /**
     * 
     * @type {Array<GetOrganizationCombo200ResponseCategoriesInnerProductsInner>}
     * @memberof GetOrganizationCombo200ResponseCategoriesInner
     */
    products: Array<GetOrganizationCombo200ResponseCategoriesInnerProductsInner>;
}

/**
 * Check if a given object implements the GetOrganizationCombo200ResponseCategoriesInner interface.
 */
export function instanceOfGetOrganizationCombo200ResponseCategoriesInner(value: object): value is GetOrganizationCombo200ResponseCategoriesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('comboId' in value) || value['comboId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('selectedByDefault' in value) || value['selectedByDefault'] === undefined) return false;
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function GetOrganizationCombo200ResponseCategoriesInnerFromJSON(json: any): GetOrganizationCombo200ResponseCategoriesInner {
    return GetOrganizationCombo200ResponseCategoriesInnerFromJSONTyped(json, false);
}

export function GetOrganizationCombo200ResponseCategoriesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationCombo200ResponseCategoriesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'comboId': json['comboId'],
        'position': json['position'],
        'enabled': json['enabled'],
        'selectedByDefault': json['selectedByDefault'],
        'min': json['min'],
        'max': json['max'],
        'products': ((json['products'] as Array<any>).map(GetOrganizationCombo200ResponseCategoriesInnerProductsInnerFromJSON)),
    };
}

export function GetOrganizationCombo200ResponseCategoriesInnerToJSON(json: any): GetOrganizationCombo200ResponseCategoriesInner {
    return GetOrganizationCombo200ResponseCategoriesInnerToJSONTyped(json, false);
}

export function GetOrganizationCombo200ResponseCategoriesInnerToJSONTyped(value?: GetOrganizationCombo200ResponseCategoriesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'comboId': value['comboId'],
        'position': value['position'],
        'enabled': value['enabled'],
        'selectedByDefault': value['selectedByDefault'],
        'min': value['min'],
        'max': value['max'],
        'products': ((value['products'] as Array<any>).map(GetOrganizationCombo200ResponseCategoriesInnerProductsInnerToJSON)),
    };
}

